import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { selectPostById, selectPostLoading } from 'src/app/core/reducers';

import { AppState } from 'src/app/reducers';
import { Post } from 'src/app/core/models/core.models';
import { Store } from '@ngrx/store';
import { UtilsService } from 'src/app/core/services/utils.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-post-full-content',
  templateUrl: './post-full-content.component.html',
  styleUrls: ['./post-full-content.component.scss'],
  standalone: false,
})
export class PostFullContentComponent implements OnInit, OnChanges {
  @Input() postId: string;
  post$: Observable<Post>;
  postLoading$: Observable<boolean>;
  videos: { href: string; type: string }[] = [];

  postUrlInternal: string;

  protected utilsService = inject(UtilsService);

  constructor(private store: Store<AppState>) {
    //console.log('post full content');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['postId'] && this.postId) {
      this.loadPostData(this.postId);
    }
  }

  ngOnInit(): void {
    if (this.postId) {
      this.loadPostData(this.postId);
    }
  }

  private loadPostData(postId: string): void {
    this.post$ = this.store.select(selectPostById(postId));
    this.postLoading$ = this.store.select(selectPostLoading(postId));
    this.postUrlInternal =
      environment.baseUrl + '/post/view/?post_id=' + postId;
    this.post$
      .pipe(
        tap((post) => {
          this.videos =
            post?.attachments
              ?.filter((a) => a.type === 'mp4' || a.type === 'video')
              .map((a) => ({
                href: a.href,
                type: a.href?.includes('youtu') ? 'video/youtube' : 'video/mp4',
              })) || [];
        }),
      )
      .subscribe();
  }

  copyToClipboard(text: string): void {
    this.utilsService.copyToClipboard(text);
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }
}
